import { Navigate, useParams, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

interface SchoolSlugGuardProps {
  children: React.ReactNode;
}

export function SchoolSlugGuard({ children }: SchoolSlugGuardProps) {
  const { schoolSlug } = useParams<{ schoolSlug: string }>();
  const user = useAuthStore((state) => state.user);
  const location = useLocation();

  // If user's school slug doesn't match URL, redirect to correct URL
  if (user && schoolSlug && user.schoolSlug !== schoolSlug) {
    // Redirect to the same path but with correct school slug
    const pathWithoutSlug = location.pathname.replace(`/${schoolSlug}`, '');
    return <Navigate to={`/${user.schoolSlug}${pathWithoutSlug}`} replace />;
  }

  return <>{children}</>;
}
